import { Icon } from "./icon";

type Props = {
  checked: boolean;
};

export function Checkbox({ checked }: Props) {
  return (
    <Icon
      color={checked ? "onSurface" : "onSurfaceDim"}
      name={checked ? "checkbox-marked" : "checkbox-blank-outline"}
    />
  );
}
